import { createClient } from "@supabase/supabase-js";

/*
  MAIN APP SUPABASE
*/

const mainSupabaseUrl =
  process.env.REACT_APP_SUPABASE_URL;

const mainSupabaseAnonKey =
  process.env.REACT_APP_SUPABASE_ANON_KEY;

export const supabase = createClient(
  mainSupabaseUrl,
  mainSupabaseAnonKey
);

/*
  MESSAGES SUPABASE
*/

const messagesSupabaseUrl =
  process.env.REACT_APP_SUPABASE_URL_MESSAGES;

const messagesSupabaseAnonKey =
  process.env.REACT_APP_SUPABASE_ANON_KEY_MESSAGES;

export const messagesSupabase = createClient(
  messagesSupabaseUrl,
  messagesSupabaseAnonKey
);